import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-condition-categor-qa-report-dw",
  templateUrl: "./condition-categor-qa-report-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConditionCategorQaReportDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.CONDITION_CATEGORY_QA_REPORT_DW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID];
}
